import { computeOptions } from '@/utils/formUtils';

import styles from './DropdownDS.module.scss';

type DropdownProps = {
  id?: string;
  label?: string;
  favorites?: Array<{ value: string | number, label: string | number }>;
  options?: Array<{ value: string | number, label: string | number }>;
  defaultValue?: string | number;
  value?: string | number;
  onChange?: (value: string | number) => void;
  onBlur?: (e: any) => void;
  size?: 'small' | 'medium';
  hintMessage?: string;
  isReadOnly?: boolean;
  isDisabled?: boolean;
  isErrored?: boolean;
  isFullWidth?: boolean;
  formData?: any;
  customClassName?: string;
};

export const Dropdown = ({
  id = '',
  label,
  favorites,
  options,
  defaultValue,
  value,
  onChange,
  onBlur,
  size = 'medium',
  hintMessage,
  isReadOnly = false,
  isDisabled = false,
  isErrored = false,
  isFullWidth = true,
  customClassName,
  ...rest
}: DropdownProps) => {
  const getDefaultValue =
    favorites?.find((o) => o.value === defaultValue)?.value ||
    options?.find((o) => o.value === defaultValue)?.value ||
    favorites?.[0]?.value ||
    options?.[0]?.value;

  const getIsDisabled = isDisabled || (options?.length === 0 && favorites?.length === 0);

  const computedId = id ? id + '-dropdown' : 'dropdown';

  const handleChange = (newValue: string | number) => {
    onChange(newValue);
  };

  const computedContainerClassName = [
    styles.container,
    styles[size],
    isFullWidth && styles['full-width'],
    customClassName && customClassName
  ].filter(Boolean).join(' ');

  const computedClassName = [
    styles.dropdown,
    label && styles['with-label'],
    getIsDisabled && styles.disabled,
    isReadOnly && styles.readonly,
    isErrored && styles.error,
  ].filter(Boolean).join(' ');

  const computedMessageClassName = [
    styles.hint,
    isErrored && styles.error
  ].filter(Boolean).join(' ');

  return (
    <div className={computedContainerClassName}>
      {label && <label htmlFor={computedId} className={styles.label}>{label}</label>}
      <select
        id={computedId}
        data-rbf={computedId}
        aria-label="dropdown"
        className={computedClassName}
        disabled={getIsDisabled}
        onMouseDown={isReadOnly ? (e) => e.preventDefault() : undefined}
        onChange={(e) => handleChange(e.target.value)}
        onBlur={onBlur ? (e) => onBlur(e.target.value) : undefined}
        value={value}
        defaultValue={getDefaultValue}
        {...rest}
      >
        {computeOptions(options, favorites)}
      </select>
      {hintMessage && <div className={computedMessageClassName}>{hintMessage}</div>}
    </div>
  );
};

export default Dropdown;
